import React from 'react';
import { Route,IndexRoute } from 'react-router';
import BreadCrumb from '../Common/BreadCrumb';
// import { lazify } from '../Common/Helper';

import VoucherExpired from '../StaticPage/VoucherExpired';

const PageWrapper = (props) => {
  return (
    <div>
      <BreadCrumb {...props}/>
      <VoucherExpired {...props}/>
    </div>
  );
};

const VoucherExpiredRoute = (
  <Route
    label='Prepaid Voucher'
    helmet={{
      title: 'Expired Voucher',
      metaDescription: 'Prepaid'
    }}
     path='expired-voucher'
    >
      <Route>
        <IndexRoute component={(PageWrapper)} />
      </Route>
  </Route>
);

export default VoucherExpiredRoute;



// WEBPACK FOOTER //
// ./src/Routes/VoucherExpiredRoute.js